export default "__VITE_ASSET__9pTjJ05f__"